/* "Complete the look" rail on the cart/checkout page.
 *
 * webshop keeps checkout (address + payment + place order) as a section of
 * the cart page itself (templates/includes/cart/place_order.html), not a
 * separate route - so one mount covers both. .cart-container only renders
 * when the cart has items (cart.html wraps it in {% if doc.items %}), so an
 * empty cart naturally shows no rail.
 *
 * Data comes from raftor_webhq.catalog.recommendations.get_recommended_items_for_cart
 * via the shared RecommendationSource (mode: 'for_cart'), seeded from the item
 * groups already in the cart.
 *
 * Mounted through window.rfhqProductCard.mountCarousel - the exact same
 * function every Item Carousel Web Page Block runs through - see pdp.js and
 * build_item_carousel.js for the full rationale; this file only differs in
 * where it inserts and which recommendation mode it asks for.
 *
 * Whether this rail is actually enabled (Raftor Storefront Feature Settings >
 * Show on Cart/Checkout Page) is enforced entirely inside RecommendationSource
 * - nothing here needs to know about that setting.
 */

import { buildRecommendationCarouselEl } from './build_item_carousel.js';

frappe.ready(function () {
	if (!window.rfhqProductCard) return;

	var cartRoot = document.querySelector('.cart-container');
	if (!cartRoot) return;

	var el = buildRecommendationCarouselEl({
		title: __('Complete the look'),
		mode: 'for_cart',
		extraClass: 'rfhq-item-carousel--cart mt-4',
	});

	cartRoot.insertAdjacentElement('afterend', el);

	window.rfhqProductCard.mountCarousel(el);
});
